<portal-main-nav>
  <!-- Service Provider Enterprises -->
  <portal-main-nav-item icon="far fa-sign-in" route="service-provider-enterprises">
    {{ (authUser$ | async)?.serviceProviderName }}
  </portal-main-nav-item>

  <!-- System info -->
  <portal-main-nav-item icon="far fa-info-circle" route="system-admin-system-info">
    <span>{{ 'menu.systemInfo' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Allowed devices -->
  <portal-main-nav-item icon="far fa-phone-office" route="system-admin-device">
    <span>{{ 'menu.systemDevice' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Files -->
  <portal-main-nav-item icon="far fa-file" route="system-admin-files">
    <span>{{ 'menu.files' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Notifications -->
  <portal-main-nav-item icon="far fa-bullhorn" route="system-admin-notifications">
    <span>{{ 'menu.notifications' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Soft clients -->
  <portal-main-nav-item icon="far fa-download" route="system-admin-soft-clients">
    <span>{{ 'menu.softClients' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Documents -->
  <portal-main-nav-item icon="far fa-book" route="system-admin-documents">
    <span>{{ 'menu.documentation' | portalTranslate }}</span>
  </portal-main-nav-item>
</portal-main-nav>
